import { addTagToCache, addTagToManagedTags, deleteTagFromCache, mergeTagInCache, updateTagInCache } from './tagsCache';

import type { CreateTags } from './CreateTags.mutation';
import type { DeleteTag } from './DeleteTag.mutation';
import type { MergeTags } from './MergeTags.mutation';
import type { UpdateTag } from './UpdateTag.mutation';
import type { Cache } from '@urql/exchange-graphcache';
import type { ResultOf, VariablesOf } from 'gql.tada';

export const tagMutationUpdates = {
  createTags: (result: ResultOf<typeof CreateTags>, args: VariablesOf<typeof CreateTags>, cache: Cache) => {
    (args.input.tags ?? []).forEach(input => {
      const tag = result.createTags?.find(created => created?._id === input?._id);
      if (tag && input?._team_id) {
        addTagToCache(cache, input._team_id, tag);
        addTagToManagedTags(cache, input._team_id, {
          ...tag,
          description: input.description ?? null,
          highlight_ids: [],
        });
      }
    });
  },

  updateTag: (result: ResultOf<typeof UpdateTag>, { input }: VariablesOf<typeof UpdateTag>, cache: Cache) => {
    if (result.updateTag) {
      updateTagInCache(cache, input);
    }
  },

  // The API sends no tag or highlight event for a delete or a merge, so the cache applies them itself.
  deleteTag: (result: ResultOf<typeof DeleteTag>, args: VariablesOf<typeof DeleteTag>, cache: Cache) => {
    if (result.deleteTag) {
      deleteTagFromCache(cache, args.input.id);
    }
  },

  // Updaters receive the field arguments, which nest the operation's variables under `input`.
  mergeTags: (
    result: ResultOf<typeof MergeTags>,
    { input }: { input: VariablesOf<typeof MergeTags> },
    cache: Cache,
  ) => {
    if (result.mergeTags) {
      mergeTagInCache(cache, input.targetTagId, input.destinationTagId);
    }
  },
};
